<template>
  <BaseBanner
    v-if="showBanner"
    @bannerClosed="closeBanner"
    data-ec="integrations-issue-banner">
    <template v-slot:title>
      {{ $t('integrationsIssueBanner.actionRequired') }}
    </template>
    <template v-slot:message>
      <span
        v-if="integrationsWithIssues.length === 1"
        data-test="integrations-issue-one-problem">
        {{ $t('integrationsIssueBanner.oneIntegrationHasAProblem', {
          name: integrationsWithIssues[0].title,
          separator: $t('banner.separator'),
        }) }}
      </span>
      <span
        v-else
        data-test="integrations-issue-multiple-problem">
        {{ $t('integrationsIssueBanner.multipleIntegrationHaveAProblem', { separator: $t('banner.separator') }) }}
      </span>
    </template>
    <template v-slot:cta>
      <span
        @click="openIntegrationsPage"
        class="underline">
        {{ $t('integrationsIssueBanner.reinstallNow') }}
      </span>
    </template>
  </BaseBanner>
</template>
<script>
  import { mapGetters } from 'vuex';
  import BaseBanner from '@/components/library/banners/BaseBanner.vue';

  export default {
    name: 'IntegrationsIssueBanner',
    components: {
      BaseBanner,
    },
    data() {
      return {
        isDismissed: false,
      };
    },
    computed: {
      ...mapGetters({
        integrations: 'integrations/integrations',
        user: 'user/user',
        userHasRole: 'roles/userHasRole',
      }),
      integrationsWithIssues() {
        return Object
          .values(this.integrations)
          .filter(integration => integration.instance?.status === 'unauthorized');
      },
      integrationsLoaded() {
        return Object.keys(this.integrations).length > 0;
      },
      showBanner() {
        return !this.isDismissed && this.isAdmin && this.integrationsWithIssues.length > 0;
      },
      isAdmin() {
        return this.userHasRole('super-admin');
      },
    },
    methods: {
      openIntegrationsPage() {
        this.$router.push({ name: 'Integrations' });
      },
      closeBanner() {
        this.isDismissed = true;
      },
      getIntegrations() {
        if (!this.integrationsLoaded && this.isAdmin) {
          this.$store.dispatch('integrations/GET_INTEGRATIONS').then(() => {
            this.gettingIntegrations = false;
          });
        }
      },
    },
    watch: {
      user() {
        this.getIntegrations();
      },
    },
    mounted() {
      this.getIntegrations();
    },
  };
</script>
